import axios from "axios";
import CamBanner from "../CamBanner";
import BaseCamApi from "./BaseCamApi";

export default class Flirt4FreeApi extends BaseCamApi {
    constructor(config) {
        super('Flirt4Free', config);

        this.apiUrl = config.flirt4free.apiUrl;
        this.autoLoginUrl = config.autoLoginUrl;
    }

    /**
     * @param {string} gender
     * @returns {Promise<object[]>}
     */
    async loadRawBanners(gender) {
        const url = new URL(this.apiUrl);
        url.searchParams.append('gender', gender);

        try {
            const response = await axios.get(url.toString());
            return Array.isArray(response.data) ? response.data : [];
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    /**
     * @param {object} rawBanner
     * @returns {CamBanner}
     */
    makeCamBanner(rawBanner) {
        const url = this.autoLoginUrl ? this.autoLoginUrl.replace(encodeURIComponent('{performer}'), encodeURIComponent(rawBanner.code)) : rawBanner.chat_link;

        return new CamBanner(
            rawBanner.code,
            rawBanner.name,
            rawBanner.categories[0].name,
            rawBanner.screencap_image,
            zone => url,
        );
    }
};
